import React from 'react';

import Message from '../../components/Message/Message';
import AddMessage from '../../components/AddMessage/AddMessage';
import './OrderDetail.scss';

class OrderDetail extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {params, addNewMessage, currentUser, users} = this.props;
        const {bookInfo, requestInfo} = this.props.requests.find((r) => {
            return r.requestInfo.requestId === params.requestId;
        });

        function parsePublicationDate() {
            var monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];
            var parsedDate = bookInfo.publicationDate.match(/([^-]+)/g);
            if (parsedDate[1]) {
                return `${monthNames[parseInt(parsedDate[1])]}, ${parsedDate[0]}`;
            }
            return parsedDate[0];
        }

        function renderMessages() {
            if (requestInfo.messages) {
                return requestInfo.messages

                    .sort((a, b) => {
                        return b.date - a.date;
                    })
                    .map((message, i) => {
                        return (
                            <div className="message" key={i}>
                                <Message message={message}/>
                            </div>
                        );
                    });
            }
        }

        const requesteeUser = users.find((user) => {
            return user.userId === requestInfo.userId;
        });

        function displayRequestee() {
            return requesteeUser ?
                (<div className="user">
                    Request Submitted By: {requesteeUser.userName.last.concat(', ', requesteeUser.userName.first)}
                </div>) : '';
        }

        return (
            <div>
                <h1>Request Detail</h1>
                <hr />
                <div className="request-detail-container">
                    {displayRequestee()}
                    <div>
                        <div className="image-container">
                            <img src={bookInfo.imageLinks.large}/>
                        </div>
                        <div className="book-info">
                            <div className="title">
                                <a href={bookInfo.productLink}
                                   target="_blank">{bookInfo.title.concat(', ', bookInfo.edition)}</a>
                            </div>
                            <div className="author">{bookInfo.author}</div>
                            <div className="publication-year">{parsePublicationDate()}</div>
                            <div className="publisher">{bookInfo.publisher}</div>
                            <div className="binding">{bookInfo.binding}</div>
                            <div className="isbn">ISBN: {bookInfo.ISBN}</div>
                            <div className="price">{bookInfo.price.FormattedPrice}</div>
                            <div className="prime">Prime Eligible: {bookInfo.primeEligible ? 'Yes' : 'No'}</div>
                            <div className="other-offers">
                                <a href={bookInfo.viewMoreOffersLink} target="_blank">View More Offers</a>
                            </div>
                            <br />
                            <div className="justification"><b>Justification:</b> {requestInfo.justification}</div>
                        </div>
                        <div className="status">
                            Request Status: {requestInfo.requestStatus}
                        </div>
                        <AddMessage requestInfo={requestInfo}
                                    addNewMessage={addNewMessage}
                                    currentUser={currentUser}
                                    params={params}/>
                        {renderMessages()}
                    </div>
                </div>
            </div>
        );
    }
}

OrderDetail.propTypes = {
    users: React.PropTypes.array
};
OrderDetail.defaultProps = {
    users: []
};

export default OrderDetail;



/** WEBPACK FOOTER **
 ** ./src/components/OrderDetail/OrderDetail.js
 **/